/* @flow */

import root from './windowCheck';
import type { ProfileCoverProps, ProfileCoverSettings } from '../types/index';

export function getInitialSettings(props: ProfileCoverProps): ProfileCoverSettings {
    return {
        disableSticky: props.disableSticky === true,
        fullStateSize: props.fullStateSize || 0,
        stickyStateSize: props.stickyStateSize || 0,
        stickyWidthThreshold: props.stickyWidthThreshold || Infinity,
        stickyHeightThreshold: props.stickyHeightThreshold || Infinity,
    };
}

export function didSettingsChange(
    prevProps: ProfileCoverProps,
    nextProps: ProfileCoverProps
): boolean {
    return (
        nextProps !== prevProps &&
        (prevProps.disableSticky !== nextProps.disableSticky ||
            prevProps.fullStateSize !== nextProps.fullStateSize ||
            prevProps.stickyStateSize !== nextProps.stickyStateSize ||
            prevProps.stickyWidthThreshold !== nextProps.stickyWidthThreshold ||
            prevProps.stickyHeightThreshold !== nextProps.stickyHeightThreshold)
    );
}

export function getWindowWidth(): number {
    return root.innerWidth || 0;
}

export function getWindowScrollPosition(): number {
    return root.scrollY || root.pageYOffset || 0;
}

export function getElementHeight(el: ?HTMLElement): number {
    return el ? el.offsetHeight : 0;
}

export function getElementPosition(el: ?HTMLElement): number {
    if (el) {
        const winScrollY = getWindowScrollPosition();
        const relativePos = el.getBoundingClientRect();

        return winScrollY + relativePos.top;
    }
    return Infinity;
}
